import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { usePathMatch } from '../../Components/PuzzleNav/hooks';
import { TabWrapper, Title } from './styled';
export const NavigationItem = memo(function NavigationItem({ title, exact, path, to, dataTestId = `nav-tab-${to}`, hidden, }) {
    const match = usePathMatch({ path: path ?? to, exact });
    if (hidden) {
        return null;
    }
    return (_jsx(TabWrapper, { to: to, as: NavLink, "$active": match, "data-testid": dataTestId, children: _jsx(Title, { "$active": match, children: title }) }));
});
